import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  rootContainer: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center',
    minHeight: '50vh',
    padding: theme.spacing(2)
  },
  formContainer: {
    maxWidth: 500,
    width: '100%',
    padding: theme.spacing(4),
    borderRadius: '27px',
    backgroundColor: theme.palette.white.main,
    boxShadow: '0 20px 54px 0 rgba(0, 0, 0, 0.2)'
  },
  formTitle: {
    marginBottom: theme.spacing(3),
    textAlign: 'center'
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(2)
  },
  submitButton: {
    margin: theme.spacing(3, 0, 2),
    padding: theme.spacing(1.5)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  signUpLink: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
    cursor: 'pointer'
  },
  fadeError: {
    animation: '$fadeOut 5s forwards'
  },
  '@keyframes fadeOut': {
    '0%': { opacity: 1 },
    '80%': { opacity: 1 },
    '100%': { opacity: 0 }
  }
}));

export default useStyles;
